<template>
  <div class="content">
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>{{ $t("edit_article_dialog_title") }}</md-dialog-title>

      <md-dialog-content>
        <form>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>{{ $t("edit_article_dialog_description") }}</label>
                <md-input
                  v-model="info"
                  type="text"
                  @input="updatedInfo = true"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>{{ $t("table_header_customer_article_number") }}</label>
                <md-input
                  v-model="customerArticleNumber"
                  type="text"
                  @input="updatedCustomerArticleNumber = true"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <h4>{{ $t("edit_article_dialog_subtitle") }}</h4>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100" v-if="amounts.length > 1">
              <md-field>
                <label for="articleId">{{ $t("choose_amount") }}</label>
                <md-select
                  v-model="selectedAmount"
                  name="articleId"
                  id="articleId"
                  @md-selected="amountSelected"
                >
                  <md-option
                    v-for="item in amounts"
                    v-bind:key="item.articleId"
                    v-bind:value="item.articleId"
                    >{{ item.quantity }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>{{ $t("table_header_fill_amount") }}</label>
                <md-input
                  v-model="amount"
                  type="text"
                  @input="updatedAmount = true"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100" v-if="prices.length > 1">
              <md-field>
                <label for="articleId">{{ $t("choose_price") }}</label>
                <md-select
                  v-model="selectedPrice"
                  name="articleId"
                  id="articleId"
                  @md-selected="priceSelected"
                >
                  <md-option
                    v-for="item in prices"
                    v-bind:key="item.supplier"
                    v-bind:value="item.supplier"
                    >{{ item.basePrice }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>{{ $t("table_header_price") }}</label>
                <md-input
                  v-model="price"
                  type="text"
                  @input="updatedPrice = true"
                ></md-input>
              </md-field>
            </div>
          </div>
        </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="commitChanges()">{{
          $t("save_button")
        }}</md-button>
      </md-dialog-actions>
    </md-dialog>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-66"
      >
        <p-s-table
          tableHeaderColor="purple"
          v-bind:title="$t('article_details_title', { article: articleName })"
          v-bind:subTitle="
            $t('article_details_subtitle', { articleNumber: articleNumber })
          "
          height="100"
          v-bind:data="this.articleSummary"
          v-bind:dict="this.articleDetailsDict"
        ></p-s-table>
          <md-button v-if="renderSelfService"
            class="md-primary"
            data-testid="edit-button"
            style="float: right; margin-right: 20px; margin-top: 0px;"
            v-on:click="openEditModal()"
            >{{ $t("edit_button") }}</md-button
          >
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          :chart-data="dailySalesChart.data"
          :chart-options="dailySalesChart.options"
          :chart-type="'Line'"
          data-background-color="blue"
          v-if="renderComponent"
        >
          <template slot="content">
            <h4 class="title">{{ $t("price_history_title") }}</h4>
            <p class="category">
              {{ $t("price_history_subtitle") }}
            </p>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>
              {{ $t("access_time", { min: "4" }) }}
            </div>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <p-s-table
          tableHeaderColor="orange"
          v-bind:title="$t('kanban_container_title')"
          v-bind:subTitle="$t('kanban_container_subtitle')"
          height="300"
          sortBy="transponder"
          v-bind:data="this.storages"
          v-bind:dict="this.storagesDict"
        ></p-s-table>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <p-s-table
          tableHeaderColor="green"
          v-bind:title="$t('order_history_title')"
          v-bind:subTitle="$t('order_history_subtitle')"
          height="300"
          sortBy="orderDate"
          sortOrder="desc"
          v-bind:data="this.positions"
          v-bind:dict="this.positionsDict"
        ></p-s-table>
      </div>
    </div>
  </div>
</template>

<script>
import ChartCard from "@/components/Cards/ChartCard";
import PSTable from "../components/Tables/PSTable";
import api from "@/api/api";
import store from "@/store/index.js";

export default {
  name: "ArticleDetails",
  components: { ChartCard, PSTable },
  data() {
    return {
      renderComponent: true,
      storages: [],
      positions: [],
      articleSummary: [],
      showDialog: false,
      info: "",
      amount: "",
      price: "",
      articleId: null,
      articles: [],
      prices: [],
      amounts: [],
      selectedAmount: null,
      selectedPrice: null,
      customerArticleNumber: "",
      updatedInfo: false,
      updatedAmount: false,
      updatedPrice: false,
      updatedCustomerArticleNumber: false,
      articleDetailsDict: [
        { key: "supplier", label: "table_header_supplier", type: "string" },
        {
          key: "supplierArticleNumber",
          label: "table_header_supplier_article_number",
          type: "string",
        },
        { key: "baseprice", label: "table_header_base_price", type: "price" },
        { key: "container", label: "table_header_container", type: "string" },
        {
          key: "kanbanvalue",
          label: "table_header_kanban_value",
          type: "price",
        },
      ],
      storagesDict: [
        {
          key: "transponder",
          label: "table_header_transponder",
          type: "string",
        },
        {
          key: "storageLocation",
          label: "table_header_storage_location",
          type: "string",
        },
        {
          key: "storageYard",
          label: "table_header_storage_position",
          type: "string",
        },
        { key: "quantity", label: "table_header_fill_amount", type: "number" },
        { key: "validFrom", label: "table_header_active_since", type: "date" },
      ],
      positionsDict: [
        { key: "order", label: "table_header_order", type: "string" },
        {
          key: "transponderId",
          label: "table_header_transponder",
          type: "string",
        },
        { key: "orderDate", label: "table_header_order_date", type: "date" },
        {
          key: "confirmedDeliveryDate",
          label: "table_header_delivery_date",
          type: "dateTime",
        },
        {
          key: "deliveryDate",
          label: "table_header_arrival_date",
          type: "dateTime",
        },
      ],
      dailySalesChart: {
        data: {},
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 200, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
    };
  },
  created() {
    this.renderComponent = false;

    store.commit("setLoading", true);

    this.pullData();

    api.getPriceHistory(this.$route.params.id).then((result) => {
      let dates = [];
      let prices = [];
      let priceHistory = result.data;

      for (let i = 0; i < priceHistory.length; i++) {
        let date = new Date(priceHistory[i].date);
        dates.push(date.toLocaleDateString());
        prices.push(parseFloat(priceHistory[i].price));
      }

      dates.push(new Date().toLocaleDateString());
      prices.push(parseFloat(priceHistory[priceHistory.length - 1].price));

      let max = Math.max.apply(null, prices) + 5;

      this.dailySalesChart.options.high = max;
      this.dailySalesChart.data.labels = dates;
      this.dailySalesChart.data.series = [prices];
      this.renderComponent = true;
    });

    api.getPositionsForArticle(this.$route.params.id).then((result) => {
      this.positions = result.data;
      this.positions.forEach((item) => {
        item.order = item.order + "-" + item.position;
      });

      store.commit("setLoading", false);
    });
  },
  methods: {
    openEditModal() {
      this.showDialog = true;
    },
    amountSelected(amount) {
      this.selectedAmount = amount;
    },
    priceSelected(price) {
      this.selectedPrice = price;
    },
    commitChanges() {
      if (this.amounts.length == 1) this.selectedAmount = this.amounts[0];
      if (this.prices.length == 1) this.selectedPrice = this.prices[0];
      if (this.updatedInfo || this.updatedCustomerArticleNumber) {
        api
          .patchArticleInfo(
            this.$route.params.id,
            this.customerArticleNumber,
            this.info
          )
          .then(() => {
            //this.pullData();
            this.$router.push("/app/articles");
          });
      }
      if (this.updatedAmount && this.selectedAmount !== null) {
        api
          .patchArticleAmount(
            this.$route.params.id,
            this.amount,
            this.selectedAmount
          )
          .then((result) => {
            this.pullData();
          });
      }
      if (this.updatedPrice && this.selectedPrice !== null) {
        api
          .patchArticlePrice(
            this.$route.params.id,
            this.price,
            this.selectedPrice
          )
          .then((result) => {
            this.pullData();
          });
      }
    },
    pullData() {
      api.getArticleSummary(this.$route.params.id).then((result) => {
        this.articleSummary = result.data;

        this.info = this.articleSummary[0].customerArticleDescription;
        this.customerArticleNumber = this.articleSummary[0].customerArticleNumber;

        this.updatedAmount = false;
        this.updatedInfo = false;
        this.updatedCustomerArticleNumber = false;
        this.updatedPrice = false;
        this.articles = [];
        this.article = null;
        this.showDialog = false;
        this.prices = [];
        this.amounts = [];

        api.getArticleVariations(this.$route.params.id).then((result) => {
          for (let i = 0; i < result.data.length; i++) {
            if (i === 0) {
              this.prices.push(result.data[i]);
            } else {
              if (this.prices[0].basePrice !== result.data[i].basePrice) {
                this.prices.push(result.data[i]);
              }
            }
          }

          for (let i = 0; i < result.data.length; i++) {
            if (i === 0) {
              this.amounts.push(result.data[i]);
            } else {
              if (this.amounts[0].quantity !== result.data[i].quantity) {
                this.amounts.push(result.data[i]);
              }
            }
          }
        });
      });
      api.getStorages(this.$route.params.id).then((result) => {
        this.storages = result.data;
      });
    },
  },
  computed: {
    articleName: function() {
      if (this.articleSummary[0] !== undefined) {
        return this.articleSummary[0].customerArticleDescription;
      } else {
        return "";
      }
    },
    articleNumber: function() {
      if (this.articleSummary[0] !== undefined) {
        return this.articleSummary[0].customerArticleNumber;
      } else {
        return "";
      }
    },
    renderSelfService() {
      return store.state.user.org == 5949363
    }
  },
};
</script>

<style scoped></style>
